

<script lang="ts">
  import type { UserViewFrameContext } from "../../_shared/_logic/user-types"
  import type { PageTabWithId } from "@kontextwerk/web-sdk/core/navigation/viewNavigation"
  import UserTabState from "@kontextwerk/control-web-frame/routes/OrgaView/subviews/User/components/UserTabState.svelte"
  import UserIntegrationsTab from "../IntegrationsPage/tabs/IntegrationsTab"

  const { viewFrameContext, activeTab } = $props<{
    viewFrameContext: UserViewFrameContext
    activeTab: string
  }>()

  const user = $derived(viewFrameContext.user)
  const loading = $derived(viewFrameContext.loading)
  const error = $derived(viewFrameContext.error)
  const canViewCalendarIntegration = $derived(viewFrameContext.canViewCalendarIntegration)
  const canManageCalendarIntegration = $derived(viewFrameContext.canManageCalendarIntegration)
  const canDisconnectOwnCalendarIntegration = $derived(
    viewFrameContext.canDisconnectOwnCalendarIntegration,
  )
  const organizationId = $derived(viewFrameContext.organizationId)
</script>

{#if activeTab === "integrations"}
  {#if !user}
    <UserTabState
      {loading}
      {error}
      userPresent={Boolean(user)}
      onRetry={viewFrameContext.onRetry ?? null}
    />
  {:else if !organizationId}
    <UserTabState
      loading={false}
      error="Die Organisation für diese Integration konnte nicht bestimmt werden."
      userPresent={true}
      onRetry={viewFrameContext.onRetry ?? null}
    />
  {:else if canViewCalendarIntegration || canDisconnectOwnCalendarIntegration}
    {#key user.id}
      <UserIntegrationsTab
        {user}
        {organizationId}
        canManage={canManageCalendarIntegration}
        canDisconnectOwn={canDisconnectOwnCalendarIntegration}
      />
    {/key}
  {/if}
{/if}
